import React, { Component } from 'react';
import DataTable from '../../../../components/DataTable/index';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { Filings } from '../../services/Filings';

const dateFormatter = new Intl.DateTimeFormat('en-US');

class FilingsEverActiveListGrid extends Component {
    render() {
        let {
            id,
            dataList,
            handleEditClick,
            selection,
            updateSelected
        } = this.props;
        return (
            <DataTable
                id={id}
                columns={[
                    {
                        title: 'Effective<br/>Date',
                        data: 'effectiveDate',
                        className: 'pr-sm'
                    },
                    {
                        title: 'Expiration<br/>Date',
                        data: 'expirationDate',
                        className: 'pr-sm'
                    },
                    {
                        title: '',
                        data: 'stateCode',
                        className: 'pr-sm'
                    },
                    {
                        title: 'Status',
                        data: 'filingStatus',
                        className: 'pr-sm'
                    },
                    {
                        title: 'Trust<br/>Name',
                        data: 'trustName'
                    },
                    {
                        title: 'Portfolio<br/>Name',
                        data: 'portfolioName'
                    },
                    {
                        title: 'Class<br/>Name',
                        data: 'className'
                    },
                    {
                        title: 'Sales<br/>Amount',
                        data: 'salesAmount'
                    },
                    {
                        title: 'Net<br/>Amount',
                        data: 'netAmount'
                    },
                    {
                        title: 'State<br/>Fee',
                        data: 'stateFee'
                    },
                    {
                        title: 'Permit<br/>Number',
                        data: 'permitNumber'
                    },
                    {
                        title: 'Edit',
                        data: null
                    }
                ]}
                data={dataList}
                selection={selection}
                pageable
                searchable
                sortable
                onSelectedItems={data => {
                    updateSelected(data);
                }}
                columnFormat={[
                    {
                        targets: [5, 6, 7, 8, 9, 10, 11],
                        orderable: false
                    },
                    {
                        //Effective / Expiration Date
                        targets: [0, 1],
                        createdCell: function(td, cellData, rowData, row, col) {
                            $(td).css('width', '5%');
                            $(td).css('text-align', 'center');
                        },
                        render: function(data, type, full) {
                            if (data) {
                                if (type === 'sort') {
                                    return data;
                                } else {
                                    let date = new Date(data);
                                    return dateFormatter.format(date);
                                }
                            }
                        }
                    },
                    {
                        //State Column
                        targets: [2],
                        createdCell: function(td, cellData, rowData, row, col) {
                            $(td).css('width', '3%');
                            $(td).css('text-align', 'center');
                        }
                    },
                    {
                        //Status column
                        targets: [3],
                        createdCell: function(td, cellData, rowData, row, col) {
                            $(td).css('width', '5%');
                            $(td).css('text-align', 'center');
                        },
                        render: (data, type, full) => {
                            let filingStatusName = Filings.getFilingStatusName(data);
                            let isSalesReport = full.isSalesReport
                                ? ' (Sales)'
                                : '';
                            return filingStatusName + isSalesReport;
                        }
                    },
                    {
                        //Trust
                        targets: [4],
                        orderData: [4],
                        createdCell: function(td, cellData, rowData, row, col) {
                            $(td).css('max-width', '95px');
                            td.title = cellData;
                        }
                    },
                    {
                        //Portfolio
                        targets: [5],
                        createdCell: function(td, cellData, rowData, row, col) {
                            $(td).css('max-width', '125px');
                            td.title = cellData;
                        }
                    },
                    {
                        //Class
                        targets: [6],
                        createdCell: function(td, cellData, rowData, row, col) {
                            $(td).css('max-width', '110px');
                            td.title = cellData;
                        }
                    },
                    {
                        //Sales Amount, Net Amount, State Fee
                        targets: [7, 8, 9],
                        createdCell: function(td, cellData, rowData, row, col) {
                            $(td).css('width', '5%');
                            $(td).css('text-align', 'right');
                        },
                        render: function(data, type, full) {
                            return (
                                '$' +
                                data
                                    .toFixed(2)
                                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                            );
                        }
                    },
                    {
                        //Permit Number - limit to 10 characters
                        targets: [10],
                        render: function(data, type, full) {
                            if (data && typeof data === 'string' && data.length > 10) {
                                return data.substring(0, 10);
                            }
                            return data || '';
                        }
                    },
                    {
                        targets: [-1],
                        render: function(data, type, full) {
                            return '<span class="label label-default" title="Edit" style="cursor: pointer; font-size: 90%" ><span class="glyphicon glyphicon-search" /></span>';
                        },
                        createdCell: function(td, cellData, rowData, row, col) {
                            let data = cellData;
                            $(td).css('width', '3%');
                            $(td).css('text-align', 'center');
                            $(td).click(cellData => {
                                handleEditClick(data);
                            });
                        }
                    }
                ]}
                rowFormat={(row, data, dataIndex) => {
                    if (selection) {
                        $(row).css('cursor', 'pointer');
                    }

                    if (data['notes']) {
                        row.title = 'Notes: ' + data['notes'];
                    }
                }}
            />
        );
    }
}

FilingsEverActiveListGrid.propTypes = {
    id: PropTypes.string,
    dataList: PropTypes.array.isRequired,
    selection: PropTypes.bool
};

FilingsEverActiveListGrid.defaultProps = {
    selection: false,
    updateSelected: () => {}
};

export default FilingsEverActiveListGrid;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/SearchFilings/FilingsEverActiveListGrid.js